/* tslint:disable:no-console */
export class ConsoleLogger {
    logInformation(message) {
        console.log(message);
    }
    logWarning(message) {
        console.warn(message);
    }
    logError(message) {
        console.error(message);
    }
}
ConsoleLogger.Instance = new ConsoleLogger();
